<template>
  <div class="md-layout px-4">
    <div class="md-layout-item md-size-100 p-0 export-header mb-6">
      {{ $t("export_student.roster_of") + " " + classInfo.name }}
    </div>
    <div class="md-layout-item md-size-100 p-0 export-title mb-3">
      {{ schoolInfo.address }}
    </div>
    <div class="md-layout-item md-size-100 md-layout p-0 mb-3">
      <div class="md-layout-item md-size-50 p-0">
        <span class="mr-2">{{ $t("export_student.term_name") }}:</span>
        <span class="export-info">{{
          classInfo.terms && classInfo.terms.name
        }}</span>
      </div>
      <div class="md-layout-item md-size-50 p-0">
        <span class="mr-2">{{ $t("export_student.subject") }}:</span>
        <span class="export-info">{{
          classInfo.subject && classInfo.subject.name
        }}</span>
      </div>
    </div>
    <div class="md-layout-item md-size-100 md-layout p-0 mb-3">
      <div class="md-layout-item md-size-50 p-0">
        <span class="mr-2">{{ $t("export_student.primary_teacher") }}:</span>
        <span class="export-info">{{ getPrimaryTeacher() }}</span>
      </div>
      <div class="md-layout-item md-size-50 md-layout p-0">
        <span class="mr-2">{{ $t("export_student.secondary_teacher") }}:</span>
        <div class="md-layout-item flex flex-col">
          <div
            v-for="(item, index) in getSecondaryTeacher()"
            :key="index + 'secondary teacher'"
          >
            <div class="export-info">{{ item }}</div>
          </div>
        </div>
      </div>
    </div>
    <md-table class="table-pdf-assessment w-full text-[12px]">
      <md-table-row class="text-center">
        <md-table-cell>{{ $t("common.no_number") }}</md-table-cell>
        <md-table-cell>{{ $t("common.student_code") }}</md-table-cell>
        <md-table-cell>{{ $t("common.username") }}</md-table-cell>
        <md-table-cell>{{ $t("class.student_col_fullname") }}</md-table-cell>
        <md-table-cell>{{ $t("common.grade") }}</md-table-cell>
        <md-table-cell>{{ $t("class.student_col_sex") }}</md-table-cell>
        <md-table-cell>{{ $t("class.student_col_score") }}</md-table-cell>
        <md-table-cell>{{ $t("class.student_col_email") }}</md-table-cell>
      </md-table-row>
      <md-table-row
        class="text-center"
        v-for="(item, index) in studentList"
        :key="index + 'table row'"
      >
        <md-table-cell>{{ index + 1 }}</md-table-cell>
        <md-table-cell>{{ item.student_code }}</md-table-cell>
        <md-table-cell>{{ item.username }}</md-table-cell>
        <md-table-cell>{{ item.full_name }}</md-table-cell>
        <md-table-cell>{{ item.grade }}</md-table-cell>
        <md-table-cell>{{ item.sex }}</md-table-cell>
        <md-table-cell>{{
          item.hasOwnProperty("score") ? Number(item.score).toFixed(2) : ""
        }}</md-table-cell>
        <md-table-cell>{{ item.email }}</md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>
<script>
import { TEACHER_ASSIGNMENTS } from "@/constants";
export default {
  props: ["classInfo", "studentList", "schoolInfo"],
  data() {
    return {};
  },
  methods: {
    getPrimaryTeacher() {
      const primaryTeacher = this.classInfo.teachers.find(
        item => item.assignment === TEACHER_ASSIGNMENTS.PRIMARY
      );
      if (!primaryTeacher) return "";
      return primaryTeacher.users?.user_no_sql?.full_name;
    },

    getSecondaryTeacher() {
      const secondaryTeachers = this.classInfo.teachers.filter(
        item => item.assignment === TEACHER_ASSIGNMENTS.SECONDARY
      );
      return secondaryTeachers.map(item => item.users?.user_no_sql?.full_name);
    }
  }
};
</script>
<style lang="scss" scoped>
.export-header {
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  letter-spacing: -0.02em;
  color: #000000;
}
.export-title {
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  letter-spacing: -0.02em;
  color: #000000;
}
.export-info {
  font-weight: 500;
  color: #3c4858;
}
</style>
